import React from 'react';
import { connect } from 'react-redux';

import { prepareNum, unitTransform } from '@services/helper.service';
import { defaultUnits } from '@config';
import { standardList } from './../../../../app.values';
import ResultsOfDesignEU from './components/ResultsOfDesignEU';
import ResultsOfDesignICC from './components/ResultsOfDesignICC';
import ResultsOfDesignANZ from './components/ResultsOfDesignANZ';
import ResultsOfDesignCSA from './components/ResultsOfDesignCSA';
import ResultsOfDesignMasonry from './components/ResultsOfDesignMasonry';
import ResultsOfDesignAnnexC_AS from './components/ResultsOfDesignAnnexC_AS';

class CalculateResultsOfDesign extends React.Component {

  render() {
		const ResultsOfDesign = this.props.designStandard ? this.componentMap[this.props.designStandard] : ResultsOfDesignEU;
    return (
      <div>
        <ResultsOfDesign prepareValue={this.prepareUnitValue}/>
      </div>
    );
  }

  componentMap = {
    [standardList['EU']]: ResultsOfDesignEU,
    [standardList['ICC.Post']]: ResultsOfDesignICC,
    [standardList['ICC.Cast']]: ResultsOfDesignICC,
    [standardList['ANZ']]: ResultsOfDesignANZ,
    [standardList['CSA']]: ResultsOfDesignCSA,
    [standardList['AS5216']]: ResultsOfDesignAnnexC_AS,
    [standardList['Masonry']]: ResultsOfDesignMasonry,
    [standardList['AnnexC']]: ResultsOfDesignAnnexC_AS,
  };

  prepareUnitValue(value) {
    // VladP: Check if values are allowed before transforming (ex. 99999)
    if (Number.isFinite(prepareNum(+value, true))) {
      return prepareNum(unitTransform(+value).from(defaultUnits.LOAD).to(this.props.loadUnit, true), false, 2, true);
    }
  
    return prepareNum(+value, true);
  }

}

const mapState = state => {
  const data = state.selectors.calculate[state.main.appType];

  if (data && data.gridSelectedItem) {
    return {
      selectedItem: data.gridSelectedItem,
      loadUnit: state.main.units.load,
      designStandard: state.main.localization.designStandard
    };
  }

  return {};
};

export default connect(mapState)(CalculateResultsOfDesign);



// WEBPACK FOOTER //
// ./src/views/Calculate/components/CalculateResultsOfDesign/index.js